import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { WEBBACK_V2_API } from "@constants"
import { brand } from "@signals"


export default function CommonFiltersBrand({ ...props }) {
    const optionBrand = useSignal([])
    const inputValue = useSignal()

    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${WEBBACK_V2_API}/master-data/brand/options`}
        label="Brands"
        placeholder="Search Brand..."
        options={optionBrand.value}
        value={brand.value}
        filterOptions={(options, { inputValue }) => options.filter(op => {
            if (op.value === "select_all") return true
            return op.label.toLowerCase().includes(inputValue.toLowerCase())
        })}
        onInputChange={(_, newInputValue) => {
            if (newInputValue.length)
                inputValue.value = newInputValue
        }}
        formatOptionLabel={({ label, value }) => {
            if (value === "select_all")
                return <Box borderBottom="1px solid" width={1}>
                    {label}
                </Box>
            return label
        }}
        onChange={e => {
            if (props.multiple !== false && e.target.value.includes("select_all")) {
                brand.value = [...brand.value, ...optionBrand.value.filter(op => op.value !== "select_all")
                    .filter(op => op.label.toLowerCase().includes(inputValue.value.toLowerCase()))
                    .map(op => op.value)
                ]
            } else {
                brand.value = e.target.value
            }
            inputValue.value = ""
        }}
        onFinishAjax={options => {
            optionBrand.value = [
                ...props.multiple !== false ? [{label: "Select All", value: "select_all"}] : [],
                ...options
            ]
        }}
        {...props}
    />
}